module.exports = __webpack_public_path__ + "media/images/icons/outlined/html5-d9e09163cb60734898b9c4173c1173a1.svg";